var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-date-picker',{staticClass:"rounded-lg",attrs:{"weekday-format":_vm.setDay,"show-adjacent-months":"","color":"var(--primary-black)","no-title":""},on:{"input":_vm.selectedDate},model:{value:(_vm.syncDate),callback:function ($$v) {_vm.syncDate=$$v},expression:"syncDate"}})
}
var staticRenderFns = []

export { render, staticRenderFns }